import { createExtensionTemplateReader } from '@next-adapter/extension-template-reader.js'

export const presetTemplates = createExtensionTemplateReader('presets')
